import type { DimensionOf } from "./types";

export const dimensionOf: DimensionOf = ({ suggestion, key }) =>
  suggestion.dimensions.find((dimension) => dimension.key === key) ?? null;
